import { render } from "./TextContentComponent.vue?vue&type=template&id=037dd8fc&scoped=true"
import script from "./TextContentComponent.vue?vue&type=script&lang=js"
export * from "./TextContentComponent.vue?vue&type=script&lang=js"

import "./TextContentComponent.vue?vue&type=style&index=0&id=037dd8fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037dd8fc"]])

export default __exports__